const modalAction = () => {

  // // Première modal infos pratiques carte
  // const modalBtn1 = document.querySelector('.modal-infos-btn-1');
  // const modalBg1 = document.querySelector('.modal-bg-1');
  // const modalClose1 = document.querySelector('.modal-close-1');

  // if (modalBtn1) {
  //   modalBtn1.addEventListener('click', () => {
  //     modalBg1.classList.add('modal-bg-active');
  //   });

  //   modalClose1.addEventListener('click', () => {
  //     modalBg1.classList.remove('modal-bg-active');
  //   });
  // }

  // // Deuxième modal infos pratiques plan

  // const modalBtn2 = document.querySelector('.modal-infos-btn-2');
  // const modalBg2 = document.querySelector('.modal-bg-2');
  // const modalClose2 = document.querySelector('.modal-close-2');

  // if (modalBtn2) {
  //   modalBtn2.addEventListener('click', () => {
  //     modalBg2.classList.add('modal-bg-active');
  //   });

  //   modalClose2.addEventListener('click', () => {
  //     modalBg2.classList.remove('modal-bg-active');
  //   });
  // }

  // Troisième modal infos pratiques moments forts

  // const modalBtn3 = document.querySelector('.modal-infos-btn-3');
  // const modalBg3 = document.querySelector('.modal-bg-3');
  // const modalClose3 = document.querySelector('.modal-close-3');

  // if (modalBtn3) {
  //   modalBtn3.addEventListener('click', () => {
  //     modalBg3.classList.add('modal-bg-active');
  //   });

  //   modalClose3.addEventListener('click', () => {
  //     modalBg3.classList.remove('modal-bg-active');
  //   });
  // }

  // Quatrième modal plan des stands (délégation : OK après refresh Turbolinks / re-render AJAX)
  if (!window.__standsReservationModalBound) {
    window.__standsReservationModalBound = true

    document.addEventListener("click", (event) => {
      const openBtn = event.target.closest(".modal-stands-btn")
      if (openBtn) {
        if (
          openBtn.classList.contains("button--disabled") ||
          openBtn.getAttribute("aria-disabled") === "true"
        ) {
          return
        }
        window.openStandsReservationModal?.()
        return
      }

      const closeBtn = event.target.closest(".modal-close-4")
      if (closeBtn) {
        const modalBg4 = document.querySelector(".modal-bg-4")
        if (!modalBg4) return
        window.closeStandsReservationModal?.()
        return
      }

      const arrowDown = event.target.closest(".arrow-down")
      if (arrowDown) {
        const modal = document.querySelector(".modal-bg-4.modal-bg-active")
        if (modal) modal.scrollTop += 1000
      }
    })
  }

  // Conservé pour les .js.erb existants : réactive la sélection des stands après re-render.
  window.showStandsModal = () => {
    window.initRegistrationStandsSelection?.()
  }

  window.clearStandsModalScrollLock = () => {
    document.body.classList.remove("swal2-shown", "swal2-height-auto")
    document.documentElement.classList.remove("swal2-shown", "swal2-height-auto")
    document.body.style.paddingRight = ""
  }

  window.openStandsReservationModal = () => {
    const modalBg4 = document.querySelector(".modal-bg-4")
    if (!modalBg4) return

    window.clearStandsModalScrollLock()
    document.body.style.overflow = "hidden"
    document.querySelector(".navbar")?.classList.add("d-none")
    modalBg4.classList.add("modal-bg-active")
    window.showStandsModal()
  }

  window.closeStandsReservationModal = () => {
    const modalBg4 = document.querySelector(".modal-bg-4")
    window.clearStandsModalScrollLock()
    document.body.style.overflow = ""
    document.querySelector(".navbar")?.classList.remove("d-none")
    modalBg4?.classList.remove("modal-bg-active")
  }

  // Après un innerHTML sur #create-exhibitor-stands-form : la modal est recréée sans classe active.
  window.restoreStandsReservationModalOpen = () => {
    window.openStandsReservationModal()
  }
}

export { modalAction };
